<div data-cy="professional-nav" class="professional-nav" [class.evaluate-and-decide]="activePhase === 'ead'">
  <div class="phase-and-categories">
    <button mat-button color="accent" class="phase" data-cy="phase-structure-and-estimate" (click)="switchToEvaluateAndDecide()">
      <mat-icon class="phase-icon">analytics</mat-icon>
      <span class="phase-title name" i18n>Strukturieren und Schätzen</span>
      <span class="phase-title change" i18n
        >Wechseln zu <br />
        Bewerten und Entscheiden</span
      >
      <mat-icon class="phase-icon" iconPositionEnd>keyboard_double_arrow_down</mat-icon>
    </button>
    <div
      mat-tab-nav-bar
      mat-stretch-tabs="false"
      [tabPanel]="tabPanel.nativeElement"
      color="accent"
      class="tool-categories"
      [disablePagination]="true"
      [disableRipple]="true"
    >
      <div mat-tab-link [active]="activeTool === 'sae-overview'">
        <dt-pf-tool [(activeTool)]="activeTool" [tool]="'sae-overview'"></dt-pf-tool>
      </div>

      <div mat-tab-link [active]="activeTool === 'sae-assumptions'">
        <dt-pf-tool [(activeTool)]="activeTool" [tool]="'sae-assumptions'"></dt-pf-tool>
      </div>

      <div mat-tab-link [active]="SAE_OBJECTIVES_TOOL_CATEGORY.includes(activeTool)">
        <dt-pf-tool categoryName="Ziele" i18n-categoryName [(activeTool)]="activeTool" [toolsInCategory]="SAE_OBJECTIVES_TOOL_CATEGORY">
        </dt-pf-tool>
      </div>

      <div mat-tab-link [active]="SAE_ALTERNATIVES_TOOL_CATEGORY.includes(activeTool)">
        <dt-pf-tool
          categoryName="Alternativen"
          i18n-categoryName
          [(activeTool)]="activeTool"
          [toolsInCategory]="SAE_ALTERNATIVES_TOOL_CATEGORY"
        >
        </dt-pf-tool>
      </div>

      <div mat-tab-link [active]="activeTool === 'sae-influence-factors'">
        <dt-pf-tool [(activeTool)]="activeTool" [tool]="'sae-influence-factors'"></dt-pf-tool>
      </div>

      <div mat-tab-link (click)="openGlobalVariables()">
        <div class="single-tool-button" i18n>Globale Variablen</div>
      </div>
    </div>
  </div>

  <div class="phase-and-categories">
    <button mat-button color="accent" class="phase" data-cy="phase-evaluate-and-decide" (click)="switchToStructureAndEstimate()">
      <mat-icon class="dt-smaller-icon phase-icon">gavel</mat-icon>
      <span class="phase-title name" i18n>Bewerten und Entscheiden</span>
      <span class="phase-title change" i18n
        >Wechseln zu <br />
        Strukturieren und Schätzen</span
      >
      <mat-icon class="phase-icon" iconPositionEnd>keyboard_double_arrow_up</mat-icon>
    </button>

    <div
      mat-tab-nav-bar
      mat-stretch-tabs="false"
      [tabPanel]="tabPanel.nativeElement"
      color="accent"
      class="tool-categories"
      [disablePagination]="true"
      [disableRipple]="true"
    >
      <div mat-tab-link [active]="activeTool === 'ead-overview'">
        <dt-pf-tool [(activeTool)]="activeTool" [tool]="'ead-overview'"></dt-pf-tool>
      </div>

      <div mat-tab-link [active]="activeTool === 'ead-utility-functions'">
        <dt-pf-tool [(activeTool)]="activeTool" [tool]="'ead-utility-functions'"></dt-pf-tool>
      </div>

      <div mat-tab-link [active]="activeTool === 'ead-objective-weighting'">
        <dt-pf-tool [(activeTool)]="activeTool" [tool]="'ead-objective-weighting'"></dt-pf-tool>
      </div>

      <div mat-tab-link [active]="EAD_EVALUATION_TOOL_CATEGORY.includes(activeTool)">
        <dt-pf-tool
          categoryName="Auswertung"
          i18n-categoryName
          [(activeTool)]="activeTool"
          [toolsInCategory]="EAD_EVALUATION_TOOL_CATEGORY"
        >
        </dt-pf-tool>
      </div>
    </div>
  </div>
</div>

<dt-scroll-shadow #tabPanel="dtElementRef" dtElementRef class="outer-professional-tab-container">
  <dt-scroll-shadow-inner [class.dt-limit-width]="limitWidth" class="inner-professional-tab-container">
    <router-outlet #toolOutlet="outlet" (activate)="setPhaseAndTool($event, toolOutlet.activatedRoute)"></router-outlet>
  </dt-scroll-shadow-inner>
</dt-scroll-shadow>

<dt-legal [horizontalLayout]="true"></dt-legal>
